"use client";

import type { ReactNode } from "react";
import { useState } from "react";

interface FallbackImageProps {
	src: string;
	alt: string;
	className?: string;
	loading?: "eager" | "lazy";
	fetchPriority?: "auto" | "high" | "low";
	fallback?: ReactNode;
}

/**
 * Renders an <img>, but if the file is missing (e.g. not generated yet) it
 * silently shows the optional fallback instead of a broken-image icon. Lets us
 * wire image slots into the landing before the art assets exist.
 */
function FallbackImage(prop: FallbackImageProps) {
	const { src, alt, className, loading = "lazy", fetchPriority, fallback = null } = prop;
	const [failed, setFailed] = useState(false);
	if (failed) return <>{fallback}</>;
	return (
		// oxlint-disable-next-line nextjs/no-img-element -- the onError fallback below is this component's whole purpose
		<img
			src={src}
			alt={alt}
			className={className}
			loading={loading}
			fetchPriority={fetchPriority}
			onError={() => setFailed(true)}
		/>
	);
}

export default FallbackImage;
